import {
  BookOpen,
  Calendar,
  ClipboardList,
  Clock,
  FileStack,
  GitCompare,
  Globe,
  History,
  LayoutDashboard,
  Map,
  PackageSearch,
  Rocket,
  Settings,
  ShieldAlert,
  ShieldCheck,
  Sparkles,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { SUPERADMIN_ROUTES } from './routes';

export interface SuperAdminMenuItem {
  label: string;
  path: string;
  icon: LucideIcon;
}

export interface SuperAdminMenuGroup {
  key: 'overview' | 'admin' | 'permissions' | 'operations';
  label: string;
  items: SuperAdminMenuItem[];
}

export const SUPERADMIN_MENU_GROUPS: SuperAdminMenuGroup[] = [
  {
    key: 'overview',
    label: 'Overview',
    items: [
      { label: 'Dashboard', path: SUPERADMIN_ROUTES.DASHBOARD, icon: LayoutDashboard },
    ],
  },
  {
    key: 'admin',
    label: 'Admin',
    items: [
      { label: 'Users & Roles', path: SUPERADMIN_ROUTES.USERS, icon: Users },
      { label: 'Application Settings', path: SUPERADMIN_ROUTES.APPLICATION_SETTINGS, icon: Settings },
      { label: 'Audit Trails', path: SUPERADMIN_ROUTES.AUDIT_REPORT, icon: ClipboardList },
      { label: 'System Logs', path: SUPERADMIN_ROUTES.ERROR_LOGS, icon: ShieldAlert },
      { label: 'Dashboard Governance', path: SUPERADMIN_ROUTES.DASHBOARD_GOVERNANCE, icon: Map },
      { label: 'Program Setup', path: SUPERADMIN_ROUTES.PROGRAM_SETUP_NEW, icon: Sparkles },
      { label: 'Program Configuration Studio', path: SUPERADMIN_ROUTES.PROGRAM_CONFIGURATION_STUDIO, icon: PackageSearch },
      { label: 'Program Requests', path: SUPERADMIN_ROUTES.PROGRAM_REQUESTS, icon: ClipboardList },
      { label: 'Releases', path: SUPERADMIN_ROUTES.RELEASES, icon: Rocket },
      { label: 'User Guidance', path: SUPERADMIN_ROUTES.USER_GUIDANCE, icon: BookOpen },
    ],
  },
  {
    key: 'permissions',
    label: 'Permissions',
    items: [
      { label: 'Application Permissions', path: SUPERADMIN_ROUTES.APPLICATION_PERMISSIONS, icon: Globe },
      { label: 'Permission Matrix', path: SUPERADMIN_ROUTES.PERMISSION_MATRIX, icon: ShieldCheck },
      { label: 'Role Templates', path: SUPERADMIN_ROUTES.ROLE_TEMPLATES, icon: FileStack },
      { label: 'Permission Audit', path: SUPERADMIN_ROUTES.PERMISSION_AUDIT, icon: History },
      { label: 'Role Comparison', path: SUPERADMIN_ROUTES.ROLE_COMPARISON, icon: GitCompare },
    ],
  },
  {
    key: 'operations',
    label: 'Operations',
    items: [
      { label: 'Holiday Calendars', path: SUPERADMIN_ROUTES.HOLIDAY_CALENDARS, icon: Calendar },
      { label: 'Business Hours', path: SUPERADMIN_ROUTES.BUSINESS_HOURS, icon: Clock },
    ],
  },
];